var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { filter } from 'lodash';
import moment from 'moment';
import { ModalConfirmForm } from 'app/components/Modal';
import { FormData } from 'app/components/Form';
import AssetsSelect from 'app/containers/Assets/AssetsSelect/AssetsSelect.jsx';
import resources from 'app/store/resources';
import { createActivity, fetchUserActivitiesWithTaskRelation, updateActivity } from 'app/store/reducers/reduxActivities';
import { userActivitiesByTaskSelector } from 'app/store/selectors/reduxActivities';
export function AddTimeModal(props) {
    const { taskIds, userId, addTimeToSpecifiedDate = new Date(), onChange, showUserSelect } = props, modalProps = __rest(props, ["taskIds", "userId", "addTimeToSpecifiedDate", "onChange", "showUserSelect"]);
    const dispatch = useDispatch();
    const [user, setUser] = useState(null);
    const [isInit, setIsInit] = useState(!userId);
    const activities = useSelector(userActivitiesByTaskSelector(user === null || user === void 0 ? void 0 : user.id, taskIds));
    useEffect(() => {
        if (userId) {
            resources.assets.fetchOne(userId).then((res) => {
                setUser(res.resources[0]);
                setIsInit(true);
            });
        }
    }, [userId]);
    useEffect(() => {
        ;
        (() => __awaiter(this, void 0, void 0, function* () {
            if (user) {
                dispatch(fetchUserActivitiesWithTaskRelation({
                    userId: user.id,
                    queries: {
                        page_size: 1000,
                        task: taskIds,
                    },
                }));
            }
        }))();
    }, [user]);
    function onSave(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const { duration, assetUser, comment } = data;
            const date = moment(data.date).format('YYYY-MM-DD');
            const toUpdate = [];
            const toCreate = [];
            const splitedDuration = Math.round(duration / taskIds.length);
            taskIds.forEach((task) => {
                const activity = filter(activities, (activity) => activity.date === date && activity.task === task)[0];
                if (activity)
                    toUpdate.push(Object.assign(Object.assign({}, activity), { duration: activity.duration + splitedDuration, comment }));
                else
                    toCreate.push({ duration: splitedDuration, task, date, user: (user === null || user === void 0 ? void 0 : user.id) || assetUser.value, comment });
            });
            const promises = [];
            if (toCreate.length > 0) {
                const create = dispatch(createActivity({ createdActivities: toCreate, isFromMyHours: false }));
                promises.push(create);
            }
            if (toUpdate.length > 0) {
                const update = dispatch(updateActivity({ activities: toUpdate, isFromMyHours: false }));
                promises.push(update);
            }
            const res = yield Promise.all(promises);
            return res;
        });
    }
    return (_jsx(ModalConfirmForm, Object.assign({ title: `Add activity${user ? ` for ${user.name}` : ''}`, validateLabel: "Add spent time", minWidth: 500, draggable: true }, modalProps, { children: _jsx(FormData, { defaultData: {
                duration: 0,
                date: addTimeToSpecifiedDate.toISOString(),
                assetUser: user ? { label: user.name, value: user.id } : undefined,
            }, properties: [
                ...(!userId || showUserSelect
                    ? [
                        {
                            key: 'assetUser',
                            label: 'User',
                            type: 'autocomplete',
                            element: AssetsSelect,
                            elementProps: (state, setData) => ({
                                loading: !isInit,
                                isRequired: true,
                                assetTypes: ['us'],
                                onChange: (value) => {
                                    setData({ assetUser: value });
                                    setUser(value.data);
                                },
                            }),
                        },
                    ]
                    : []),
                {
                    key: 'duration',
                    label: 'Duration',
                    type: 'duration',
                    elementProps: {
                        isRequired: true,
                    },
                },
                {
                    key: 'date',
                    label: 'Date',
                    type: 'dateTime',
                    elementProps: {
                        isRequired: true,
                        max: new Date().toISOString(),
                    },
                },
                {
                    key: 'comment',
                    label: 'Comment',
                    type: 'string',
                },
            ], onSave: onSave }, String(isInit)) })));
}
